import { render, staticRenderFns } from "./navLeftList.vue?vue&type=template&id=06f294a2&scoped=true"
import script from "./navLeftList.vue?vue&type=script&lang=js"
export * from "./navLeftList.vue?vue&type=script&lang=js"
import style0 from "./navLeftList.vue?vue&type=style&index=0&id=06f294a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f294a2",
  null
  
)

export default component.exports